export interface ProblemDetails {
  type: string;
  title: string;
  status: number;
  detail: string;
  instance?: string;
}

export function isProblemDetails(value: unknown): value is ProblemDetails {
  return Boolean(value && typeof value === 'object' && 'title' in value && 'detail' in value && 'status' in value);
}
